import { css } from "@emotion/react";
import LiterataItalics from "./fonts/Literata-Italic-VariableFont_opsz,wght.ttf";
import Literata from "./fonts/Literata-VariableFont_opsz,wght.ttf";
import Manrope from "./fonts/Manrope-VariableFont_wght.ttf";
import OpenDyslexicBold from "./fonts/OpenDyslexic3-Bold.woff2";
import OpenDyslexic from "./fonts/OpenDyslexic3-Regular.woff2";

const cssReset = css`
  /*
        1. Use a more-intuitive box-sizing model.
    */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  /*
        2. Remove default margin
    */
  * {
    margin: 0;
  }
  /*
    Typographic tweaks!
        3. Add accessible line-height
        4. Improve text rendering
    */
  body {
    min-height: 100vh;
    min-height: 100dvh;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    font-family: initial;
  }
  /*
        5. Improve media defaults
    */
  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }
  /*
        6. Remove built-in form typography styles
    */
  input,
  button,
  textarea,
  select {
    font: inherit;
    color: inherit;
  }
  /*
        7. Avoid text overflows
    */
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    overflow-wrap: break-word;
  }
  /*
        8. Create a root stacking context
    */
  #root {
    isolation: isolate;
  }
`;

const appBaseCss = css`
  @font-face {
    font-family: "Manrope";
    src:
      local("Manrope"),
      url(${Manrope}) format("truetype");
  }

  @font-face {
    font-family: "Literata";
    src:
      local("Literata"),
      url(${Literata}) format("truetype");
  }

  @font-face {
    font-family: "Literata";
    src:
      local("Literata"),
      url(${LiterataItalics}) format("truetype");
    font-style: italic;
    font-weight: 100 900;
  }

  @font-face {
    font-family: "OpenDyslexic";
    src: url(${OpenDyslexic}) format("woff2");
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: "OpenDyslexic";
    src: url(${OpenDyslexicBold}) format("woff2");
    font-weight: 700;
    font-style: normal;
  }

  html {
    font-size: 16px;
  }
  body {
    font-family: "Manrope", sans-serif;
    color: #000000;
  }

  a {
    color: inherit;
  }
  button {
    cursor: pointer;

    &[disabled] {
      cursor: default;
    }
  }
  svg {
    flex: 0 0 auto;
  }

  html,
  body {
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  html::-webkit-scrollbar,
  body::-webkit-scrollbar {
    display: none;
  }

  /* Styling the Authenticator component */
  :root {
    --amplify-components-authenticator-router-box-shadow: none;

    --amplify-components-authenticator-router-border-width: 0;

    /* Primary Button */
    --amplify-components-button-primary-background-color: #283472;
    --amplify-components-button-primary-color: #fff;
    --amplify-components-button-primary-border-width: 0;
    --amplify-components-button-primary-active-background-color: #283472;

    /* Primary Button Hover */
    --amplify-components-button-primary-hover-background-color: #283472;

    /* Link Button */
    --amplify-components-button-link-color: #181f44;
    --amplify-components-button-link-hover-color: #181f44;
    --amplify-components-button-link-hover-background-color: #f8f9fd;
    --amplify-components-button-link-hover-border-color: #181f44;

    /* TextField */
    --amplify-components-textfield-color: #f4f4f6;
    --amplify-components-fieldcontrol-focus-border-color: #283472;
    --amplify-components-fieldcontrol-focus-box-shadow: 0 0 0 2px #283472;
  }

  [data-amplify-authenticator][data-variation="modal"] {
    background: linear-gradient(135deg, #fdfdfb 0%, #e0ded6 100%);
  }

  .amplify-button--primary {
    box-shadow:
      0px 0px 4px 2px rgba(65, 76, 131, 1) inset,
      0px 0px 0px 0.5px rgba(90, 100, 148, 1) inset,
      0px -17px 10px -1px rgba(32, 42, 91, 1) inset,
      0px 1px 6px rgba(9, 9, 11, 0.08),
      0px 0px 6px rgba(140, 147, 182, 1);
  }
`;

export const globalCss = css`
  ${cssReset}
  ${appBaseCss}
`;
